export const CLIENT_SUPPORT_EMAIL = 'clientsupport@marketviewedu.com';
export const CLIENT_SUCCESS_MAILTO = `mailto:${CLIENT_SUPPORT_EMAIL}`;
